/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description chomp
 */

/**
 * chomp floating point precision number to a finite precision
 *
 * @param {number} num - input number
 * @param {number} precision - digits of precision
 * @returns {number}
 */
export const chomp = (num: number, precision = 6) => {
  const numsArr = num.toString().split('.')
  if (numsArr.length > 1) {
    numsArr[1] = numsArr[1].slice(0, precision)
    return Number.parseFloat(numsArr.join('.'))
  }
  return num
}
